import React, { useContext, useEffect, useState } from 'react'
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext'
import { ChatbotContext, ChatbotContextPayload } from '../../../../../context/chatbotContext';
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import NoAuthorisedZohoAccount from './noAuthorisedZohoAccount';
import { Grid, useMediaQuery } from '@mui/material';
import GlobalButton from '../../../../utility/globalButton/button';
import IconsColor from '../../../../utility/iconsColor';
import GlobalPopUp from '../../../../utility/globalPopUp';
import CreateZohoIntegrationForm from './createZohoIntegrationForm';
import ZohoInformationCard from './zohoInformationCard';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import agent from '../../../../../services/api';
import ZohoTicketLogs from './zohoTicketLogs';
import { ZohoIntegrationOrganization } from '../../../../../models/axiosModel';
import ShowAllZohoAccount from './showAllZohoAccount';
import { confirmationPopoverInterface } from '../slack/integratedChannels';
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { useSearchParams } from 'react-router-dom';
import { GenericDataContext, GenericDataContextPayload } from '../../../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, chatbotIntegrationsBreadcrumb, homeBreadcrumb } from '../../../../../utils/breadcrumb';
import { useGenericStore } from '../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

export interface zohoAccountInfo {
  zoho_integration_id: number | null, 
  zoho_integration_organization_id: number | null,
}

const ZohoAccountIntegration = () => {

  const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload;
  const { zohoIntegrations, setZohoIntegrations, getZohoIntegrations, zohoTicketFields, getZohoTicketFieldsApi, globalIntegrationTypeList, getListOfZohoContactApi, getListOfZohoDepartmentApi, zohoContact, zohoDepartment } = useContext(IntegrationContext) as IntegrationContextPayload;
  const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
  const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;

  const { showError } = useGenericStore(useShallow((state) => ({
    showError: state.showError
  })))

  const [flagShowAllZohoAccountsDialog, setFlagShowAllZohoAccountsDialog] = useState<boolean>(false);
  const [flagCreateFormDialog, setFlagCreateFormDialog] = useState<boolean>(false); 
  const [selectedTab, setSelectedTab] = useState<string>("Configuration");

  const [confirmationPopover, setConfirmationPopover] = useState<confirmationPopoverInterface>({
    flagOpen: false,
    anchorEl: null, 
    channel_name: "",
  }); 

  const [selectedZohoAccountInfo, setSelectedZohoAccountInfo] = useState<zohoAccountInfo>({
    zoho_integration_id: null, 
    zoho_integration_organization_id: null,
  })

  const [searchParams] = useSearchParams();
  const chatbot_id = searchParams.get('chatbot_id');
  let pathname = window.location.pathname.toLowerCase();

  const innerHeight = window.innerHeight - 150;

  const breakPoints = {
    smallScreen: useMediaQuery('(max-width : 900px) and (min-width : 0px)'), 
    flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
  }

  const pollForCallbackStatus = async (stateValue: string) => {
    const pollInterval = 10000;
    const maxPollingTime = 100000;
    let elapsedTime = 0;

    const intervalId = setInterval(async () => {
      try {
        const response = await agent.getCallbackStatus.get(stateValue);

        if (response.status) {
          const integrationStatus = response?.data?.integration_status?.toLowerCase();

          if (integrationStatus === 'completed' || integrationStatus === 'failed') {
            clearInterval(intervalId);
            if (integrationStatus === 'failed') {
              showError(response?.data?.reason)
            } else {
              getZohoIntegrations();
            }
          } else {
            console.log("Callback not completed, retrying...");
          }

          elapsedTime += pollInterval;

          if (elapsedTime >= maxPollingTime) {
            console.log("Polling stopped after 1 minute.");
            clearInterval(intervalId);
          }
        } else {
          handleError(response);
        }
      } catch (error) {
        console.error("Error polling for callback status:", error);
        clearInterval(intervalId);
      } finally {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
      }
    }, pollInterval);
  };

  const handleZohoIntegration = async () => {
    try {
      setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
      let zohoIntegration = globalIntegrationTypeList.find((integration) => integration.integration_app_name?.toLowerCase() == "zoho desk");
      let currentUrl = window.location.href;
      if (zohoIntegration && zohoIntegration.integration_app_id) {
        const payload = {
          current_url: currentUrl,
          integration_app_id: zohoIntegration.integration_app_id,
        };

        const response = await agent.calendlyAuthUrlApi.post(payload);
        if (response.status) {
          const authUrl = response?.data?.auth_url;
          if (authUrl) {
            window.open(response.data.auth_url, "_blank")
            const stateValue = new URL(authUrl).searchParams.get('state');
            if (stateValue) {
              pollForCallbackStatus(stateValue);
            } else {
              console.error('State param not found in the auth_url.');
            }
          }
        } else {
          handleError(response);
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getListOfZohoContactApiCall = async (id: number) => {
    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
    const res = await getListOfZohoContactApi(id);
    if (!(res.status)) {
      handleError(res);
    }
    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
  }

  const getListOfZohoDepartmentApiCall = async (id: number) => {
    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
    const res = await getListOfZohoDepartmentApi(id);
    if (!(res.status)) {
      handleError(res);
    }
    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
  }

  const getZohoIntegrationsApiCall = async () => {
    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
    const res = await agent.getZohoIntegration.get();
    if (res.status) {
      setZohoIntegrations(res.data);
      if (chatBotDetails && chatBotDetails.chatbot_zoho_data.length > 0) {
        if (!zohoContact) {
          await getListOfZohoContactApiCall(chatBotDetails.chatbot_zoho_data[0]?.zoho_integration_organization_id);
        }
        if (!zohoDepartment) {
          await getListOfZohoDepartmentApiCall(chatBotDetails.chatbot_zoho_data[0]?.zoho_integration_organization_id);
        }
      }
    }else{
      handleError(res);
    }
    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
  }

  const getZohoTicketFieldsApiCall = async (zoho_integration_id: number | null) => {
    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
    const res = await getZohoTicketFieldsApi(zoho_integration_id);
    if (!(res.status)) {
      handleError(res);
    }
    setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
  }

  const handleAddZohoAccount = () => { 
    setFlagShowAllZohoAccountsDialog(true);
  } 

  const handleDeployZohoAccount = () => {

    // Close Add Zoho Account Popup. 
    setFlagShowAllZohoAccountsDialog(false); 
    setConfirmationPopover(({ ...confirmationPopover, anchorEl: null, flagOpen: false, channel_name: "" }));

    // Open Zoho Integration Popup.
    setFlagCreateFormDialog(true);
    if (!zohoTicketFields) {
      getZohoTicketFieldsApiCall(selectedZohoAccountInfo.zoho_integration_id);
    }
  }  

  const addZohoIntegration = (zoho_integration_id: string, account_name: string, zoho_integration_organization_id: number, event?: React.MouseEvent<HTMLButtonElement>) => {
    if(event){
      setConfirmationPopover(({ ...confirmationPopover, anchorEl: event.currentTarget, flagOpen: true, channel_name: account_name }));
    }
    setSelectedZohoAccountInfo((prev) => ({
      ...prev, 
      zoho_integration_id: Number(zoho_integration_id), 
      zoho_integration_organization_id: zoho_integration_organization_id,
    }))
  }

  useEffect(() => {
    // if (!zohoIntegrations) {
    getZohoIntegrationsApiCall(); 
    // }

    const updatedBreadcrumbs = [
        {...homeBreadcrumb}, 
        AIChatbotBreadcrumb, 
        {...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`},
        {...chatbotIntegrationsBreadcrumb, path: `/chatbot/viewchatbot/integration?chatbot_id=${chatbot_id}`}, 
        {name: "Zoho", path: `${pathname}?chatbot_id=${chatbot_id}`, isActive: true},
    ]; 
    setBreadCrumbs(updatedBreadcrumbs);
  }, [chatBotDetails])

  return (
    <>
            {zohoIntegrations && zohoIntegrations.length > 0 ? 
                <> 
                    {chatBotDetails && chatBotDetails.chatbot_zoho_data.length > 0 ? 
                      <>
                        <Grid container className={`${globalStyles.flexColumn} ${globalStyles.gapOne} ${styles.zohoIntegrationGridContainer}`} sx={{ maxHeight: `${innerHeight}px !important` }}>
                          <Grid item>
                              {!(breakPoints.flagSmallScreen) ?
                                <Grid container display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                  <Grid item className={styles.zohoTabsGrid}>
                                    <Grid container gap={1} flexWrap={"nowrap"} className={styles.zohoTabGridStyle}>
                                        <Grid item className={styles.zohoTabSelectStyle} sx={{ backgroundColor: selectedTab === "Configuration" ? "#FFFFFF" : "", boxShadow: selectedTab === "Configuration" ? "0px 0px 2px rgba(0,0,0,0.25)" : "" }}
                                          onClick={() => setSelectedTab("Configuration")}
                                        >
                                          <span className={styles.zohoTabSelectTextStyle}>Configuration</span>
                                        </Grid>
                                        <Grid item className={styles.zohoTabSelectStyle} sx={{ backgroundColor: selectedTab === "Ticket Logs" ? "#FFFFFF" : "", boxShadow: selectedTab === "Ticket Logs" ? "0px 0px 2px rgba(0,0,0,0.25)" : "" }}
                                          onClick={() => setSelectedTab("Ticket Logs")}
                                        >
                                          <span className={styles.zohoTabSelectTextStyle}>Ticket Logs</span>
                                        </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid> 
                                : 
                                <Grid container alignItems={"center"} gap="15px">
                                    <Grid item className={selectedTab === "Configuration" ? styles.zohoTabSelectedMobileStyle : styles.zohoSelectMobileStyle} onClick={() => setSelectedTab("Configuration")}>
                                      <span className={styles.zohoTabSelectTextMobileStyle}>Configuration</span>
                                    </Grid>
                                    <Grid item className={selectedTab === "Ticket Logs" ? styles.zohoTabSelectedMobileStyle : styles.zohoSelectMobileStyle} onClick={() => setSelectedTab("Ticket Logs")}>
                                      <span className={styles.zohoTabSelectTextMobileStyle}>Ticket Logs</span>
                                    </Grid>
                                </Grid>
                              }
                          </Grid>
                            
                          {selectedTab == "Configuration" ?
                            <Grid item>
                              <Grid container gap="15px">
                                {chatBotDetails.chatbot_zoho_data.map((zoho: ZohoIntegrationOrganization, ind: number) => {
                                    return (
                                      <ZohoInformationCard zoho={zoho} key={ind} />
                                    )
                                })}
                              </Grid>
                            </Grid> 
                          : 
                            <Grid item>
                              <ZohoTicketLogs zoho_integration_id={chatBotDetails.chatbot_zoho_data[0]?.zoho_integration_organization_id} />
                            </Grid>
                          }  
                        </Grid>
                      </> 
                      : 
                      <Grid item sx={{ backgroundColor: "rgba(247, 233, 255, 0.5)", borderRadius: "5px", width: "100%" }} padding={"30px"} mt={"10px"}>
                          <Grid container direction={"column"}>
                              <Grid item>
                                  <span style={{ fontSize: "15px", fontWeight: "600", color: "#353535" }}>This Chatbot is not linked with any Zoho Account Yet. </span>
                              </Grid>
                              <Grid item sx={{ paddingTop: "20px" }}>
                                  <GlobalButton 
                                      buttonText={"Add Zoho Account"} 
                                      className='primaryButtonStyle' 
                                      onClick={() => {handleAddZohoAccount();}} 
                                      sx={{ padding: "6px 20px !important" }} 
                                      startIcon={<IconsColor fillColor="#FFFFFF" iconName="plus" width="15px" height="15px" />}
                                  />
                              </Grid>
                          </Grid>
                      </Grid>
                    }
                </> 
                : 
                <NoAuthorisedZohoAccount handleZohoIntegration={handleZohoIntegration} />
            } 

      {(flagCreateFormDialog && zohoTicketFields) &&
        <GlobalPopUp
          open={flagCreateFormDialog}
          handleClose={() => setFlagCreateFormDialog(false)} 
          onClose={() =>setFlagCreateFormDialog(false)}
          flagShowCloseIcon 
          titlePadding='0px'
          borderRadius='10px'
          flagBackdrop
          paperMinWidth={breakPoints.smallScreen ? "65%" : '50vw'} 
          height='100%'
        >
          <CreateZohoIntegrationForm 
            setFlagCreateFormDialog={setFlagCreateFormDialog} 
            zoho_integration_organization_id={selectedZohoAccountInfo.zoho_integration_organization_id}
          />
        </GlobalPopUp>
      } 

      {flagShowAllZohoAccountsDialog && 
        <GlobalPopUp
          open={flagShowAllZohoAccountsDialog}
          handleClose={() => setFlagShowAllZohoAccountsDialog(false)}
          flagShowCloseIcon 
          title='Integrate Zoho Account'
          paperMinWidth={breakPoints.smallScreen ? '85%' : '90vw'}
          height='90vh'
        > 
          <ShowAllZohoAccount 
            confirmationPopover={confirmationPopover} 
            setConfirmationPopover={setConfirmationPopover} 
            handleDeployZohoAccount={handleDeployZohoAccount} 
            addZohoIntegration={addZohoIntegration} 
            handleZohoIntegration={handleZohoIntegration}
          />
        </GlobalPopUp>
      }
    </>
  )
}

export default ZohoAccountIntegration
